import React from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Checkbox from "@material-ui/core/Checkbox";
const useHeadStyles = makeStyles((theme) => ({
  customCell: {
    padding: "16px",
  },
}));
function EnhancedTableHead(props) {
  const classes = useHeadStyles();
  const {
    t,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    handleRequestSort,
    onRequestSort,
    headCells = [],
    showCheckBox,
  } = props;
  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {showCheckBox && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ "aria-label": "select all desserts" }}
            />
          </TableCell>
        )}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.key}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.key ? order : false}
            className={classes.customCell}
          >
            {onRequestSort && (
              <TableSortLabel
                active={orderBy === headCell.key}
                direction={order}
                onClick={createSortHandler(headCell.key)}
              >
                {t(headCell.label)}
              </TableSortLabel>
            )}
            {!onRequestSort && <div>{t(headCell.label)}</div>}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.array.isRequired,
};

export default translate("translations")(EnhancedTableHead);
